import { render, staticRenderFns } from "./onboarding-tour.vue?vue&type=template&id=38e7e907&scoped=true&"
import script from "./onboarding-tour.vue?vue&type=script&lang=js&"
export * from "./onboarding-tour.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-tour.vue?vue&type=style&index=0&id=38e7e907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e7e907",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
